<template>
  <main>
    <div class="page-content">
      <div class="container-fluid">
        <div class="row">
         <div class="col-12">
            <div class="page-title-box d-flex align-items-center justify-content-between">
               <h4 class="mb-0 font-size-18">Server Versions</h4>
               <div class="page-title-right">
                  <ol class="breadcrumb m-0">
                     <li class="breadcrumb-item"><a href="javascript: void(0);">Your Server</a></li>
                     <li class="breadcrumb-item active">Versions</li>
                  </ol>
               </div>
            </div>
         </div>
      </div>
      <!-- end page title -->
      <div class="row">
         <div class="col-xl-3 col-sm-6">
            <div class="card text-center">
               <div class="card-body">
                  <div class="avatar-sm mx-auto mb-4">
                     <img class="rounded-circle avatar-sm" src="assets/images/versions/vanilla.png" alt="">
                  </div>
                  <h5 class="font-size-15"><a href="#" class="text-dark">Vanilla Minecraft</a></h5>
                  <p class="text-muted">Select Version</p>
                  <div>
                     <div class="btn-group" role="group">
                        <button id="btnGroupVerticalDrop1" type="button" class="btn btn-primary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        Change Version <i class="mdi mdi-chevron-down"></i>
                        </button>
                        <div class="dropdown-menu" aria-labelledby="btnGroupVerticalDrop1">
                           <a class="dropdown-item" href="#">1.16.1</a>
                           <a class="dropdown-item" href="#">1.16</a>
                           <a class="dropdown-item" href="#">1.15.2</a>
                           <a class="dropdown-item" href="#">1.15.1</a>
                        </div>
                     </div>
                     <button type="button" class="btn btn-secondary waves-effect waves-light">Installed 1.16.2</button>
                  </div>
               </div>
            </div>
         </div>
         <div class="col-xl-3 col-sm-6">
            <div class="card text-center">
               <div class="card-body">
                  <div class="avatar-sm mx-auto mb-4">
                     <img class="rounded-circle avatar-sm" src="assets/images/versions/spigot.png" alt="">
                  </div>
                  <h5 class="font-size-15"><a href="#" class="text-dark">Spigot</a></h5>
                  <p class="text-muted">Select Version</p>
                  <div>
                     <div class="btn-group" role="group">
                        <button id="btnGroupVerticalDrop1" type="button" class="btn btn-primary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        Latest 1.16.2 <i class="mdi mdi-chevron-down"></i>
                        </button>
                        <div class="dropdown-menu" aria-labelledby="btnGroupVerticalDrop1">
                           <a class="dropdown-item" href="#">1.16.1</a>
                           <a class="dropdown-item" href="#">1.16</a>
                           <a class="dropdown-item" href="#">1.15.2</a>
                           <a class="dropdown-item" href="#">1.15.1</a>
                        </div>
                     </div>
                     <button type="button" class="btn btn-success waves-effect waves-light">Install</button>
                  </div>
               </div>
            </div>
         </div>
         <div class="col-xl-3 col-sm-6">
            <div class="card text-center">
               <div class="card-body">
                  <div class="avatar-sm mx-auto mb-4">
                     <img class="rounded-circle avatar-sm" src="assets/images/versions/forge.png" alt="">
                  </div>
                  <h5 class="font-size-15"><a href="#" class="text-dark">Forge</a></h5>
                  <p class="text-muted">Select Version</p>
                  <div>
                     <div class="btn-group" role="group">
                        <button id="btnGroupVerticalDrop1" type="button" class="btn btn-primary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        Latest 1.16.2 <i class="mdi mdi-chevron-down"></i>
                        </button>
                        <div class="dropdown-menu" aria-labelledby="btnGroupVerticalDrop1">
                           <a class="dropdown-item" href="#">1.16.1</a>
                           <a class="dropdown-item" href="#">1.16</a>
                           <a class="dropdown-item" href="#">1.15.2</a>
                           <a class="dropdown-item" href="#">1.15.1</a>
                        </div>
                     </div>
                     <button type="button" class="btn btn-success waves-effect waves-light">Install</button>
                  </div>
               </div>
            </div>
         </div>
         <div class="col-xl-3 col-sm-6">
            <div class="card text-center">
               <div class="card-body">
                  <div class="avatar-sm mx-auto mb-4">
                     <img class="rounded-circle avatar-sm" src="assets/images/versions/paper.png" alt="">
                  </div>
                  <h5 class="font-size-15"><a href="#" class="text-dark">PaperSpigot</a></h5>
                  <p class="text-muted">Select Version</p>
                  <div>
                     <div class="btn-group" role="group">
                        <button id="btnGroupVerticalDrop1" type="button" class="btn btn-primary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        Latest 1.16.2 <i class="mdi mdi-chevron-down"></i>
                        </button>
                        <div class="dropdown-menu" aria-labelledby="btnGroupVerticalDrop1">
                           <a class="dropdown-item" href="#">1.16.1</a>
                           <a class="dropdown-item" href="#">1.16</a>
                           <a class="dropdown-item" href="#">1.15.2</a>
                           <a class="dropdown-item" href="#">1.15.1</a>
                        </div>
                     </div>
                     <button type="button" class="btn btn-success waves-effect waves-light">Install</button>
                  </div>
               </div>
            </div>
         </div>
      </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: 'Versions',
  data () {
    return { }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/panel/Versions.vue